import React from 'react'

import {
  LoadingPanel,
  type LoadingPanelProps,
} from '~/components/elements/LoadingPanel'

export type SuspenseProps = {
  children?: React.ReactNode
  'data-testid'?: string
  loading?: boolean
  loadingContainerSize?: LoadingPanelProps['containerSize']
}

export const Suspense = ({
  children,
  'data-testid': dataTestId = 'components-elements-suspense',
  loading = false,
  loadingContainerSize,
}: SuspenseProps) =>
  loading ? (
    <LoadingPanel
      containerSize={loadingContainerSize}
      data-testid={dataTestId}
    />
  ) : (
    <>{children}</>
  )
